// extracted by mini-css-extract-plugin
export default {"moduleClass":"mAUsxKwzAm9kSHKiUnAA","test":"wH2eaKze98YYH6gdFaxU"};